import { render, staticRenderFns } from "./UserListSideMenu.vue?vue&type=template&id=2ba818e0"
import script from "./UserListSideMenu.vue?vue&type=script&lang=js"
export * from "./UserListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports